import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';

import 'ScssComponents/_navbar.scss';

function Navbar({ $navbar }) {
	window.addEventListener('scroll', () => {
		$navbar.classList.toggle('navbar--open_state', window.scrollY > 0);
	});

	gsap.registerPlugin(ScrollToPlugin);

	const $links = Array.from($navbar.querySelectorAll('.navbarLink'));

	$links.forEach($link => {
		$link.addEventListener('click', (event) => {
			const href = $link.getAttribute('href');

			const hrefRegex = /^#[A-Za-z]+[\w\-:.]*$/;

			if (href && hrefRegex.test(href)) {
				event.preventDefault();

				const offsetY = $link.dataset.scrollToOffset || 0;

				gsap.to(window, {
					duration: 0.3,
					scrollTo: { y: href, offsetY },
				});
			}
		});
	});
}

export { Navbar };
